export default "__VITE_ASSET__CgH1PVlx__"